import { FC, useEffect, useMemo } from 'react'
import { generate } from 'randomstring'
import styles from 'components/features/coaching/advisorVideoCall/TestCam/TestCam.styl'
import { createAgoraStream } from 'components/features/videoCalls/agoraHelpers'
import { Stream } from 'agora-rtc-sdk'
import PersonSvg from 'icons/person.svg'
import SvgIcon from 'components/atoms/SvgIcon'
import { useStoreDispatch, useStoreSelector } from 'helpers/reactReduxHelpers'
import { SetMediaPermissionsAction, AgoraVideoInputAction } from 'components/features/videoCalls/types/actions'
import { DEFAULT_VIDEO_HEIGHT, DEFAULT_VIDEO_WIDTH } from 'components/features/videoCalls/constants'

const getVideoDeviceId = (stream: Stream) => {
  const track = stream.getVideoTrack() as MediaStreamTrack
  return track?.getCapabilities().deviceId ?? null
}

export const TestCam: FC = () => {
  const nodeId = useMemo(generate, [])

  const camPermissions = useStoreSelector((state) => state.app.videoCall.permissions.cam)
  const isEnabled = useStoreSelector((state) => state.app.videoCall.localStream.videoMuteState === 'unmute')
  const videoDeviceId = useStoreSelector((state) => state.app.videoCall.localStream.videoInputDeviceId)

  const dispatch = useStoreDispatch()

  useEffect(() => {
    if (camPermissions === 'denied' || !isEnabled) {
      return
    }

    let isDestroyed = false
    let localStream: Stream | null = null
    createAgoraStream(1, {
      video: true,
      audio: false,
      ...(videoDeviceId ? { cameraId: videoDeviceId } : {}),
    }).then((nextStream) => {
      if (isDestroyed) {
        nextStream.stop()
        nextStream.close()
        return
      }
      localStream = nextStream
      localStream.play(nodeId)

      const nextVideoDeviceId = getVideoDeviceId(localStream)
      if (videoDeviceId === nextVideoDeviceId) {
        return
      }
      dispatch(new AgoraVideoInputAction(nextVideoDeviceId))
    }).catch(() => {
      if (isDestroyed) {
        return
      }
      dispatch(new SetMediaPermissionsAction({
        cam: 'denied',
      }))
    })

    return () => {
      isDestroyed = true
      if (!localStream) {
        return
      }
      localStream.stop()
      localStream.close()
    }
  }, [camPermissions, dispatch, nodeId, videoDeviceId, isEnabled])

  return (
    <div className={ styles.video }>
      <svg xmlns='http://www.w3.org/2000/svg' width={ DEFAULT_VIDEO_WIDTH } height={ DEFAULT_VIDEO_HEIGHT } className={ styles.placeholder } />
      <div className={ styles.person }>
        <div className={ styles.personWrapper }>
          <div className={ styles.personIconWrapper }>
            <div className={ styles.personIcon }>
              <SvgIcon src={ PersonSvg } />
            </div>
          </div>
        </div>
      </div>

      { isEnabled && (
        <div id={ nodeId } className={ styles.videoWrapper } />
      )}
    </div>
  )
}
